import React, {Component} from 'react';
import {Link} from 'react-router';

import SNIntro from './components/sn_intro';
import Perks from './components/perks';
import Footer from 'js/components/footer';

export default class SalesDirector extends Component {
    render() {
        return (
            <div id="job-page">
                <header className="header-blue">
                    <div id="sn-logo" className="hide show@sm">
                        <Link to="/">

                        </Link>
                    </div>
                    <div id="sn-logo-mobile" className="hide@sm">
                        <Link to="/">

                        </Link>
                    </div>
                    <div className="header-title">
                        <h2>Sales Director</h2>
                        <Link to="/jobs">Back To Jobs</Link>
                    </div>
                </header>
                <section id="policy">
                    <div className="terms-body">
                        <SNIntro />
                        <p className="p2">
                            We are seeking a <b>Sales Director</b> to acquire strategic accounts, assist in growing a start-up from nearly the ground floor, and showcase passion throughout that journey.
                        </p>
                        <p className="p1"><span className="s1"><b>Responsibilities</b></span></p>
                        <ul className="l1">
                            <li className="p3">
                                Secure client meetings (10 meetings per week), present to prospects, and submit proposals – own the sales cycle from lead generation to close.
                            </li>
                            <li className="p3">
                                Develop a strategic approach to building the roster of our new accounts.
                            </li>
                            <li className="p3">
                                Actively participate in major industry events and conferences.
                            </li>
                            <li className="p3">
                                Exceed revenue goals provided to you by leadership.
                            </li>
                            <li className="p3">
                                Engage with the Account Management team to help position and upsell existing clients.
                            </li>
                        </ul>
                        <p className="p1"><span className="s1"><b>Skills & Qualifications</b></span></p>
                        <ul className="l1">
                            <li className="p3">
                                Ability to succeed in a start-up environment where nothing comes easy and one must remain scrappy at all costs.
                            </li>
                            <li className="p3">
                                A positive attitude and professional behavior while advocating a team approach to the business.
                            </li>
                            <li className="p3">
                                6-12+ years of successful digital advertising sales to both agency and client direct.
                            </li>
                            <li className="p3">
                                Experience building and maintaining strong, long-lasting client relationships.
                            </li>
                            <li className="p3">
                                Demonstrated ability to communicate, present and influence credibly and efficiently at all levels of the organization, including executive and C-level.
                            </li>
                            <li className="p3">
                                Excellent listening, problem-solving, and negotiation skills.
                            </li>
                            <li className="p3">
                                Superior presentation skills.
                            </li>
                            <li className="p3">
                                A background working within the Social Advertising or Influencer Marketing space is a plus.
                            </li>
                            <li className="p3">
                                Able to travel as needed to meet prospective clients.
                            </li>
                            <li className="p3">
                                BA/BS degree or equivalent.
                            </li>
                        </ul>

                        <Perks />

                        <div className="link">
                            <a href="mailto:info@socialnative.com">
                                Interested? Shoot us a note telling us why.
                            </a>
                        </div>
                    </div>
                </section>
                <Footer dontShowJobs={true}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/pages/jobs_pages/sales_director.js